module.exports = __webpack_public_path__ + "static/img/accueil.7934a5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sachassou/visuels/accueil.png
// module id = qMKM
// module chunks = 1